const en = {
  link: {
    enter_link_title_en: "Enter link title",
    enter_link: "Enter link",
    add_icon: "ADD ICON",
    save_cap: "SAVE",
    delete_cap: "DELETE",
    link_cap: "LINK",
    add: "Add",
    edit: "Edit",
    link_is_required: "Link Title is required",
    link_url_required: " Link URL required",
    select_lang: "Select A Language",
  },

  avatar: {
    save_cap: "SAVE",
    delete_cap: "DELETE",
    add: "Add",
    edit: "Edit",
    avatar: "Avatar",
    drop_your_img: "Drop your image here or",
    browse_image: "BROWSE IMAGE",
    maximum: "Maximum",
    choose_another: "CHOOSE ANOTHER",
    size: "Size",
    select_lang: "Select A Language",
    shape: "Shape",
  },

  qr_code: {
    save_cap: "SAVE",
    delete_cap: "DELETE",
    add: "Add",
    edit: "Edit",
    select_lang: "Select A Language",
    Qr_code: "QR Code",
  },

  texteditor: {
    save_cap: "SAVE",
    delete_cap: "DELETE",
    add: "Add",
    edit: "Edit",
    select_lang: "Select A Language",
    text: "TEXT",
  },
  faq: {
    faq: "FAQ",
    add_faq: "Add FAQs",
    question_required: "Question required",
    answer_required: "Answer required",
    enter_question: "Enter Question",
    enter_answer: "Enter Answer",
    save_cap: "SAVE",
    select_lang: "Select A Language",
    delete_cap: "DELETE",
    add: "Add",
    edit: "Edit",
  },
  media: {
    enter_link: "Enter link",
    select_lang: "Select A Language",
    save_cap: "SAVE",
    delete_cap: "DELETE",
    add: "Add",
    edit: "Edit",
  },
  image: {
    image: "Image",
    drop_your_img: "Drop your image here or",
    browse_image: "BROWSE IMAGE",
    maximum: "Maximum",
    description: "Description",
    enter_alt_text: "Enter ALT Text",
    save_cap: "SAVE",
    delete_cap: "DELETE",
    add: "Add",
    edit: "Edit",
    select_lang: "Select A Language",
    choose_another: "CHOOSE ANOTHER",
  },
  imagegrid: {
    add_image_grid: "Add Image Grid",
    maximum: "Maximum",
    drop_your_img: "Drop your image here or",
    browse_image: "BROWSE IMAGE",
    select_lang: "Select A Language",
    save_cap: "SAVE",
    delete_cap: "DELETE",
    add: "Add",
    edit: "Edit",
    image_grid: "Image Grid",
  },
  divider: {
    divider: "Divider",
    divider_cap: "DIVIDER",
    color: "Color",
    select_lang: "Select A Language",
    add: "Add",
    edit: "Edit",
    add_divider: "ADD DIVIDER",
    save_cap: "SAVE",
    delete_cap: "DELETE",
  },
  addcountdown: {
    countdown: "Countdown",
    add_countdown: "ADD COUNTDOWN TIMER",
    select_lang: "Select A Language",
    enter_countdown_description: "Enter Countdown Description",
    choose_date: "Choose Date",
    choose_time: "Choose Time",
    timer_digit_color: "Timer Digit color",
    timer_background_color: "Timer Background Color",
    save_cap: "SAVE",
    delete_cap: "DELETE",
    edit_countdown: "EDIT COUNTDOWN TIMER",
  },
  header: {
    header: "Header",
    add_header: "ADD HEADER",
    enter_page_name: "Enter Page Name",
    enter_page_title: "Enter Page Title",
    pagename_required: "PageName is Required",
    pagetitle_required: "PageTitle is Required",
    contact_required: "Contact is Required",
    edit_header: "EDIT HEADER",
    whatapp_required: "Whatsapp is Required",
    whatapp: "Whatsapp",
    profile_alignment: "PROFILE ALIGNMENT",
    left: "Left",
    center: "Center",
    right: "Right",
    want_to_set_background_image: "WANT TO SET BACKGROUND IMAGE",
    avatar_size: "AVATAR SIZE",
    avatar_shape: "AVATAR SHAPE",
    avatar_outline: "AVATAR OUTLINE",
    select_lang: "Select A Language",
    add: "Add",
    edit: "Edit",
    image_smaller_than_3MB: "Image must be smaller than 3MB",
    save_cap: "SAVE",
    delete_cap: "DELETE",
    choose_avatar: "CHOOSE AVATAR",
    contact: "Contact",
    drop_your_img: "Drop your image here or",
    browse_image: "BROWSE IMAGE",
    maximum: "Maximum",
    choose_another: "CHOOSE ANOTHER",
    yes: "Yes",
    no: "No",
    circle: "Circle",
    corners: "corners",
    rounded: "Rounded",
    straight: "Straight",
    color: "Color",
  },
  socials: {
    socials: "Socials",
    save_cap: "SAVE",
    select_lang: "Select A Language",
    delete_cap: "DELETE",
    add: "Add",
    edit: "Edit",
    enter: "Enter",
  },
  location: {
    addpin: 'Add Pin',
    cancel_adding_pin: 'Cancel Adding Pin',
    adress: 'Adress',
    adress_placeholder: '123 Main St, City',
    phone: 'Phone',
    phone_placeholder: '123-456-7890',
    add_location: 'Add Location',
    set_primary: 'Set as Primary',
    primary_location: 'Primary Location',
    get_directions: 'Get Directions',
    added_any_location: "You haven't added any Location",
    adress_title_caps: 'ADD ADDRESS TITLE',
    adress_details_caps: 'ADD ADRESS DETAILS',
    enter_location_name: 'Enter Location Name',
    enter_location_adress: 'Enter Location Adress',
    enter_location_phone: 'Enter Location Phone',
    set_default_location: 'Set this location as your main/default',
    home: 'Home',
    select_lang: "Select A Language",
    save_cap: "SAVE",
    delete_cap: "DELETE",
    add_location: "ADD LOCATION",
    edit_location: "EDIT LOCATION",
  },
  want_to_delete: 'Are you sure you want to delete this?',
  cancel: 'Cancel',
  delete_cap: "DELETE",
};

export default en;
